import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { EnumToArrayPipe } from './enum-to-array.pipe';

@NgModule({
  declarations:[FilterPipe, SearchPipe, ShortNamePipe, EnumToArrayPipe],
  imports:[CommonModule],
  exports:[FilterPipe, SearchPipe, ShortNamePipe, EnumToArrayPipe]
})

export class PipeModule{}
